import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Heading } from '@treams/treams-ui';

export default function DevelopmentPlan(props: {
	name: string;
	item: graphql.EvaluationDevelopmentPlanItem;
	readonly?: boolean;
}) {
	const { localize } = useLocalize();

	return <Heading>{localize(props.item.title).text}</Heading>;
}
